export enum ACTION_TYPE {
    CREATE = "CREATE",
    EDIT = "EDIT",
    DETAIL = "DETAIL",
    DELETE = "DELETE",
    STATUS = "STATUS",
    NONE = "NONE",
    SEND = "SEND",
    CONFIRM = "CONFIRM",
    REJECT = "REJECT",
}